import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row, Footer } from 'mdbreact';
import { Link } from "react-router-dom";

class FooterPage extends Component {
    render() {
        return (
            <Footer color="blue-grey" className="page-footer font-small lighten-4 pt-3"  >
                <Container className="mt-5 mb-4 text-center text-md-right rtl">
                    <Row className="mt-3">
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>آنچه باید بدانید</strong></h6>
                            <hr className="default-color accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                            {/*<p><Link to="/how-it-works" className="dark-grey-text">پایگاه دانش</Link></p>*/}
                            <p><Link to="/business" className="dark-grey-text">کسب و کار</Link></p>
                            <p><Link to="/merchant-partners" className="dark-grey-text">همکاران تجاری</Link></p>
                            <p><Link to="/careers" className="dark-grey-text">فرصت های شغلی</Link></p>

                        </Col>

                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>حقوقی</strong></h6>
                            <hr className="default-color accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                            <p><Link to="/licences" className="dark-grey-text">مجوزها</Link></p>
                            <p><Link to="/terms-of-use" className="dark-grey-text">شرایط استفاده</Link></p>
                            <p><Link to="/privacy-policy" className="dark-grey-text">حریم خصوصی</Link></p>
                            <p><Link to="/rules-of-use" className="dark-grey-text">قوانین استفاده</Link></p>

                        </Col>
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>دسترسی سریع</strong></h6>
                            <hr className="default-color accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                            <p><Link to="/about" className="dark-grey-text">درباره ما</Link></p>
                            <p><Link to="/how-it-works" className="dark-grey-text">سوالات متداول</Link></p>
                            <p><Link to="/sitemap" className="dark-grey-text">راهنمای سایت</Link></p>
                            <p><Link to="/contact-us" className="dark-grey-text">تماس با ما</Link></p>

                        </Col>
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>با ما همراه باشید</strong></h6>
                            <hr className="default-color accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                            <p>
                                <a className="fb-ic ml-0" target="_blank"><i className="fa fa-facebook mr-4"> </i></a>
                                <a className="tw-ic" target="_blank"><i className="fa fa-twitter  mr-4"> </i></a>
                                <a className="gplus-ic" target="_blank"><i className="fa fa-google-plus  mr-4"> </i></a>
                                <a className="li-ic" target="_blank"><i className="fa fa-linkedin  mr-4"> </i></a>
                                <a className="ins-ic" target="_blank"><i className="fa fa-instagram  mr-4"> </i></a>
                            </p>

                        </Col>
                    </Row>
                </Container>

                <div className="footer-copyright text-center" >
                    <Container fluid>
                        &copy; {(new Date().getFullYear())} Copyright: <a href="https://directory.atldmo.ir">  Atlantis iCity </a>
                    </Container>
                </div>
            </Footer>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(FooterPage);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js